import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './create-admin.css';
import AllUsers from '../all-users/all-users';
import { showSuccessToast, showErrorToast } from '../toast-utils';
import { tenant_list, create_admin } from '../apis';

function CreateAdmin(props) {
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    tenant_name: '',
    email: '',
    user_type: 'admin',
    password: 'password'
  });

  const [formErrors, setFormErrors] = useState({});
  const [touchedFields, setTouchedFields] = useState({});

  const [tenantList, setTenantList] = useState([]);

  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [showAllUsers, setShowAllUsers] = useState(false);


  const getCurrentUserToken = () => {
    const currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
    return currentUser.token || '';
  }

  useEffect(() => {
    const fetchTenantList = async () => {
      let userToken = getCurrentUserToken();
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${userToken}`
      }
      try {
        const res = await axios.get(tenant_list, { headers: headers });
        const data = res.data;
        const tenant_names = data.map((item) => item.tenant_name);
        setTenantList(tenant_names);
      } catch (error) {
        if (error.response && error.response.data.message === "No record found") {
          //setEmptyData(true);
        }
        if (error.response && error.response.data.msg === "Token has expired") {
          props.onLogout('token');
        }
        console.log(error)
      }
    };
    fetchTenantList();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleInputBlur = (e) => {
    const { name } = e.target;
    setTouchedFields((prevTouched) => ({
      ...prevTouched,
      [name]: true,
    }));
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.first_name) {
      errors.first_name = 'First Name is required';
    }
    if (!formData.last_name) {
      errors.last_name = 'Last Name is required';
    }
    if (!formData.tenant_name) {
      errors.tenant_name = 'Tenant Name is required';
    }
    if (!formData.email) {
      errors.email = 'Email ID is required';
    }
    if (!formData.user_type) {
      errors.user_type = 'User Type is required';
    }
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const getRandom = (lengthOfCode, possible) => {
    var text = "";
    for (var i = 0; i < lengthOfCode; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  };

  const handleSubmit = async (e) => {
    setIsButtonDisabled(true);
    e.preventDefault();
    setTouchedFields({
      first_name: true,
      last_name: true,
      tenant_name: true,
      email: true,
    });
    const isFormValid = validateForm();
    if (isFormValid) {
      const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890";
      const password = getRandom(8, possible);
      setFormData((prevData) => ({
        ...prevData,
        password: password,
      }))
    } else {
      console.log('Form has errors, please fill in all required fields.');
    }
    setIsButtonDisabled(false);
  };

  useEffect(() => {
    const isFormValid = validateForm();
    const password = formData.password;
    if (isFormValid) {
      if (password !== 'password') {
        sendFormDataToAPI(formData);
      }
    }
  }, [formData]);

  const sendFormDataToAPI = async (formData) => {
    let payload = formData;
    let userToken = getCurrentUserToken();
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${userToken}`
    }
    try {
      const res = await axios.post(create_admin, payload, { headers: headers });
      const userDetails = [
        {
          username: res.data.email_id,
          password: res.data.password
        }
      ];
      showSuccessToast("Admin successfully created");
      const keys = ['username', 'password'];
      const csvHeaders = ['Username', 'Password'];
      const csvData = convertToCSV(userDetails, keys, csvHeaders);
      const blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
      const dwldLink = document.createElement('a');
      const url = URL.createObjectURL(blob);
      const isSafariBrowser = navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1;

      if (isSafariBrowser) {
        dwldLink.setAttribute('target', '_blank');
      }

      dwldLink.setAttribute('href', url);
      dwldLink.setAttribute('download', 'user_details.csv');
      dwldLink.style.visibility = 'hidden';
      document.body.appendChild(dwldLink);
      dwldLink.click();
      document.body.removeChild(dwldLink);
    } catch (error) {
      console.log('Error', error);
      if (error.response && error.response.data.msg === "Token has expired") {
        props.onLogout('token');
      }
    }
    setTimeout(() => {
      setIsButtonDisabled(false);
      setShowAllUsers(true);
    }, 3000);

  };

  const convertToCSV = (objArray, keys, headerList) => {
    let array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
    let str = '';
    let row = 'S.No,';

    for (let index in headerList) {
      row += headerList[index] + ',';
    }

    row = row.slice(0, -1);
    str += row + '\r\n';

    for (let i = 0; i < array.length; i++) {
      let line = (i + 1) + '';

      for (let index in keys) {
        let head = keys[index];
        line += ',' + JSON.stringify(array[i][head]);
      }

      str += line + '\r\n';
    }
    return str;
  };

  return (
    <div className="main-create">
      {showAllUsers ? (
        <AllUsers />
      ) : (
        <form onSubmit={handleSubmit}>
          <div className="items d-flex flex-row justify-content-between">
            <div className="item d-flex flex-column align-items-start">
              <label>First Name</label>
              <div>
                <input name="first_name" type="text" value={formData.first_name} className="custom-input"
                  onChange={handleInputChange}
                  onBlur={handleInputBlur} /><br />
                {touchedFields.first_name && !formData.first_name && <span className="error-message">{formErrors.first_name}</span>}
              </div>
            </div>
            <div className="item d-flex flex-column align-items-start">
              <label>Last Name</label>
              <div>
                <input name="last_name" type="text" value={formData.last_name} className="custom-input"
                  onChange={handleInputChange}
                  onBlur={handleInputBlur} /><br />
                {touchedFields.last_name && !formData.last_name && <span className="error-message">{formErrors.last_name}</span>}
              </div>
            </div>
          </div>
          <div className="items d-flex flex-row justify-content-between">
            <div className="item d-flex flex-column align-items-start">
              <label>Tenant Name</label>
              <div>
                <select name="tenant_name" id="tenName" value={formData.tenant_name} className="custom-input"
                  onChange={handleInputChange}
                  onBlur={handleInputBlur}>
                  <option value="">Select</option>
                  {tenantList.map((tenant) => (
                    <option key={tenant} value={tenant}>
                      {tenant}
                    </option>
                  ))}
                </select><br />
                {touchedFields.tenant_name && !formData.tenant_name && <span className="error-message">{formErrors.tenant_name}</span>}
              </div>
            </div>
            <div className="item d-flex flex-column align-items-start">
              <label>Email ID</label>
              <div>
                <input name="email" type="text" value={formData.email} className="custom-input"
                  onChange={handleInputChange}
                  onBlur={handleInputBlur} /><br />
                {touchedFields.email && !formData.email && <span className="error-message">{formErrors.email}</span>}
              </div>
            </div>
          </div>
          <div className="items d-flex flex-row justify-content-between align-items-center">
            <div className="item d-flex flex-column align-items-start">
              <label>Role</label>
              <div>
                <select name="user_type" id="cars" onChange={handleInputChange} onBlur={handleInputBlur} className="custom-input">
                  <option value="">Select</option>
                  <option value="admin">Admin</option>
                </select><br />
                {touchedFields.user_type && !formData.user_type && <span className="error-message">{formErrors.user_type}</span>}
              </div>
            </div>
          </div>
          <div className="submit d-flex flex-row justify-content-end">
            <button type="submit" disabled={isButtonDisabled} className={isButtonDisabled ? 'disabledButton' : 'btn btn-default'}>
              Submit
            </button>
          </div>
        </form>
      )}
    </div>
  );
};

export default CreateAdmin;

